import React, { FC } from 'react';
import { Box, Link } from '@material-ui/core';

import { useSocialConnections } from 'hooks';

interface Props {
  accountId: string;
}

const LinkedInPages: FC<Props> = ({ accountId }) => {
  const { linkedInPages } = useSocialConnections();

  if (!linkedInPages.length) {
    return null;
  }

  const filteredPages = linkedInPages.filter(page => page.id === accountId);

  return (
    <Box paddingLeft="44px">
      {filteredPages.map(page => (
        <Link
          gutterBottom
          display="block"
          target="_blank"
          href={page.profile_url}
          key={page.identifier}
          color="textSecondary"
        >
          {page.profile_name}
        </Link>
      ))}
    </Box>
  );
};

export default LinkedInPages;
